<template>
  <div class="layout-page">
    <div class="layout-top">
      <div></div>
      <div>
        <el-dropdown @command="handleCommand" trigger="click">
          <span class="el-dropdown-link">
            {{userName}}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item command="info">修改密码</el-dropdown-item> -->
            <el-dropdown-item divided command="exit">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="tags">
      <div v-for="(item,index) in tagsList" :key="index">
        <router-link :to="item.path">
          <div class="tags-li" :class="{'active': isActive(item.path)}">
            {{item.title}}
            <!-- <span class="tags-li-icon" @click="refresh(index)" v-if="isActive(item.path)"><i class="el-icon-refresh"></i></span> -->
            <span class="tags-li-icon" @click.prevent="closeTags(index)"><i class="el-icon-close"></i></span>
          </div>
        </router-link>
      </div>
      <div class="tags-close-box">
        <el-dropdown @command="handleTags">
          <el-button size="mini" type="primary">
            标签选项<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu size="small" slot="dropdown">
            <el-dropdown-item command="other">关闭其他</el-dropdown-item>
            <el-dropdown-item command="all">关闭所有</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import bus from './bus';
import { log } from 'util';
export default {
  data() {
    return {
      tagsList: [],
      userName: Lockr.get('skinUserName'),
      showNotify: false,
    }
  },
  methods: {
    handleCommand(command) {
      console.log(command)
      if (command == 'info') {
        this.info();
      } else if (command == 'exit') {
        this.exit();
      }
    },
    info() {
      router.push('/home/info');
    },
    exit() {
      api.request("/employee/exit", {
        token: Lockr.get("skinToken")
      }, (res) => {
        // Lockr.flush()
        Lockr.rm('skinToken');
        Lockr.rm('skinUserName');
        Lockr.rm('skinEmpId');
        Lockr.rm('skinPermission');
        Lockr.rm('skinJurisdictionId');
        Lockr.rm('skinJurisdictionName');
        Lockr.rm('skinMobile');
        router.push('/login')
      })
    },
    isActive(path) {
      return path === this.$route.fullPath.split('?')[0];
    },
    // 关闭单个标签
    closeTags(index) {
      const delItem = this.tagsList.splice(index, 1)[0];
      const item = this.tagsList[index] ? this.tagsList[index] : this.tagsList[index - 1];
      if (item) {
        delItem.path === this.$route.fullPath && this.$router.push(item.path);
      } else {
        this.$router.push('/');
      }
      bus.$emit('tags', this.tagsList);
    },
    refresh(index) {
      console.log(this.$refs);
      // this.$router.go(0);
    },
    // 关闭全部标签
    closeAll() {
      this.tagsList = [];
      this.$router.push('/');
    },
    // 关闭其他标签
    closeOther() {
      const curItem = this.tagsList.filter(item => {
        return item.path === this.$route.fullPath;
      })
      this.tagsList = curItem;
      bus.$emit('tags', this.tagsList);
    },
    // 设置标签
    setTags(route) {
      const isExist = this.tagsList.some(item => {
        return item.path === route.fullPath;
      })
      // if (route.meta.title != "交接") {
      if (!isExist) {
        const isExistName = this.tagsList.some(item => {
          return item.title === route.meta.title;
        })
        if (!isExistName) {
          // tab标签长度为八个限制
          // if (this.tagsList.length >= 8) {
          //   this.tagsList.shift();
          // }
          this.tagsList.push({
            title: route.meta.title,
            path: route.fullPath,
            name: route.name
          })
        }
      }
      // }

      bus.$emit('tags', this.tagsList);
    },
    handleTags(command) {
      command === 'other' ? this.closeOther() : this.closeAll();
    }
  },
  computed: {
    showTags() {
      return this.tagsList.length > 0;
    }
  },
  watch: {
    $route(newValue, oldValue) {
      this.setTags(newValue);
    }
  },
  created() {
    this.setTags(this.$route);
    // 监听关闭当前页面的标签页
    bus.$on('close_current_tags', () => {
      for (let i = 0, len = this.tagsList.length; i < len; i++) {
        const item = this.tagsList[i];
        if (item.path === this.$route.fullPath) {
          if (i < len - 1) {
            this.$router.push(this.tagsList[i + 1].path);
          } else if (i > 0) {
            this.$router.push(this.tagsList[i - 1].path);
          } else {
            this.$router.push('/');
          }
          this.tagsList.splice(i, 1);
          break;
        }
      }
    })
  }
}

</script>


<style scoped>
.layout-top {
  line-height: 40px;
  height: 40px;
  padding: 0px 15px;
  /* text-align: right; */
  /* background: red; */
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.layout-top img {
  height: 40px;
}
.tags {
  position: relative;
  /* height: 40px; */
  overflow: hidden;
  /* background: #fff; */
  padding-right: 120px;
  /* box-shadow: 0 5px 10px #ddd; */
}

.tags ul {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  margin: 0px;
  padding: 0px;
}
.tags ul li {
  text-decoration: none;
  border-bottom: 0px;
}

.tags-li {
  float: left;
  margin: 3px 5px 2px 3px;
  border-radius: 3px;
  font-size: 12px;
  overflow: hidden;
  cursor: pointer;
  height: 30px;
  line-height: 30px;
  border: 1px solid #ddd5d5;
  background: #c0c4cc;
  padding: 0 5px 0 12px;
  vertical-align: middle;
  color: #fff;
  -webkit-transition: all 0.3s ease-in;
  -moz-transition: all 0.3s ease-in;
  transition: all 0.3s ease-in;
}

.tags-li:not(.active):hover {
  background: #7ac7f4;
}

.tags-li.active {
  color: #fff;
  background: #7ac7f4;
}

.tags-li-title {
  float: left;
  margin-right: 5px;
  color: #666;
}

.tags-li.active .tags-li-title {
  color: #fff;
}

.tags-close-box {
  position: absolute;
  right: 0;
  top: 0;
  box-sizing: border-box;
  padding-top: 8px;
  text-align: center;
  box-shadow: -3px 0 15px 3px rgba(0, 0, 0, 0.1);
  z-index: 10;
}
</style>
